<template>
  <multiple_form
    :forms="forms"
    :edit="true"
    :editData="props.editData"
    :disabled="true"
    :submitBtn="false"
    :isScroll="false"
  />
</template>
<script setup>
  import { defineProps, computed } from 'vue'
  import multiple_form from '@/components/multiple_form'
  import { gender, cargoType } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  //初始化
  const props = defineProps({
    editData: Object,
    data: Array,
  })

  const detailNeedRecord = computed(() => {
    return props.editData?.vehicle_type?.need_record!= 1
  })
  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '申请人（司机）信息',
      id: 'applicant_information',
      // dataInObject: 'carApplication',
      formItem: [
        {
          type: 'input',
          field: 'application_number',
          label: '车辆预约单号',
        },
        {
          type: 'input',
          field: 'applicant_name',
          label: '姓名',
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'applicant_idcard',
          label: '证件号码',
        },
        {
          type: 'select',
          field: 'applicant_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'applicant_phone',
          label: '联系电话',
        },
        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
        },
      ],
    },
    {
      name: '车辆信息',
      id: 'vehicle_information',
      formItem: [
        {
          type: 'select',
          field: 'vehicle_type_id',
          label: '车型(行驶证)',
          dataInObject: 'carInfo',
          storeOptions: 'carModel',
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
          dataInObject: 'carInfo',
        },
        {
          type: 'select',
          field: 'license_plate_color',
          storeOptions: 'plateColorType',
          getName: true,
          label: '车牌颜色',
          dataInObject: 'carInfo',
        },
        {
          type: 'select',
          field: 'color_id',
          label: '车辆颜色',
          storeOptions: 'vehicleColorType',
          // getName: true,
          dataInObject: 'carInfo',
        },

        {
          type: 'input',
          field: 'vehicle_license_number',
          label: '车辆识别代号',
          dataInObject: 'carInfo',
        },
        /*{
          type: 'input',
          field: 'engine_number',
          label: '发动机号码',
          dataInObject: 'carInfo',
        },*/
        {
          type: 'select',
          field: 'cargo_type',
          options: constantToOptions(cargoType),
          label: '货物类型',
          required: false,
          dataInObject: 'carInfo',
          hidden: props.editData?.vehicle_type?.show_cargo_type != 1,
        },
        {
          type: 'input',
          field: 'cargo_name',
          label: '货物名称',
          required: false,
          dataInObject: 'carInfo',
          hidden: props.editData?.vehicle_type?.show_cargo_type != 1,
        },
        {
          type: 'input',
          field: 'total_mass',
          label: '车辆总质量KG(行驶证)',
          required: false,
          dataInObject: 'carInfo',
          hidden: props.editData?.vehicle_type?.check_overweight != 1
        },
        {
          type: 'input',
          field: 'remark',
          label: '备注',
          dataInObject: 'carInfo',
        },
        {
          type: 'image',
          field: 'vehicle_img',
          label: '车辆正面照片',
          dataInObject: 'carInfo',
        },
        { 
          type: 'image', 
          field: 'img12123', 
          label: '12123交警平台车辆信息截图或行驶证正反面（有最新年检记录）、交强险保单图片（货车类型必须加车身侧面图片；重型大车必须加商业险保单图片）',
          dataInObject: 'carInfo',
        }, 
        { 
          type: 'image', 
          field: 'blind_video_photo', 
          label: '盲区监控视频图片（1.前侧右侧盲区安装证明，2.能同时看见车牌号与前右侧盲区摄像头和声光报警器的车身图片，3.驾驶室内盲区显示屏）',
          dataInObject: 'carInfo',
          hidden: props.editData?.vehicle_type?.need_blind_video == 0,
        }, 
        { 
          type: 'image', 
          field: 'register_record_photo', 
          label: '备案车辆信息登记表',
          dataInObject: 'carInfo',
          hidden: detailNeedRecord.value,
        },
      ],
    },
    /*{
      name: '危险品货物清单',
      id: 'cargo_info',
      submitInObject: true,
      // hidden: !showDanger.value,
      hidden: props.editData?.cargo_type != '1',
      dataInObject: 'cargo_info',
      formItem: [
        {
          type: 'input',
          field: 'cargo_number',
          label: '运单编号',
        },
        {
          type: 'input',
          field: 'cargo_quantity',
          label: '货物数量（计数单位）',
        },
        {
          type: 'input',
          field: 'enterprise',
          label: '企业名称(承运方)',
        },
        {
          type: 'input',
          field: 'unified_social_credit_code',
          label: '统一信用代码(承运方)',
        },
        {
          type: 'input',
          field: 'business_license_number',
          label: '承运人经营许可证号',
        },
        {
          type: 'input',
          field: 'contact_phone',
          label: '承运人联系电话',
        },
        {
          type: 'input',
          field: 'vehicle_transport_license',
          label: '车辆道路运输证号',
        },
        {
          type: 'input',
          field: 'business_license_number',
          label: '承运人经营许可证号',
        },
        {
          type: 'input',
          field: 'trailer_license',
          label: '挂车号牌',
        },
        {
          type: 'input',
          field: 'trailer_trasport_license',
          label: '挂车道路运输证号',
        },
        {
          type: 'input',
          field: 'driver',
          label: '驾驶员姓名',
        },
        {
          type: 'input',
          field: 'driver_qualification_certificate',
          label: '驾驶员从业资格证号',
        },
        {
          type: 'input',
          field: 'driver_phone',
          label: '驾驶员联系电话',
        },
        {
          type: 'input',
          field: 'supercargo',
          label: '押运员姓名',
        },
        {
          type: 'input',
          field: 'supercargo_qualification_certificate',
          label: '押运员从业资格证号',
        },
        {
          type: 'input',
          field: 'supercargo_phone',
          label: '押运员联系电话',
        },
        {
          type: 'input',
          field: 'shipper',
          label: '托运人姓名',
        },
        {
          type: 'input',
          field: 'shipper_phone',
          label: '托运人联系电话',
        },
        {
          type: 'input',
          field: 'recipient',
          label: '收货人姓名',
        },
        {
          type: 'input',
          field: 'recipient_phone',
          label: '收货人联系电话',
        },
        {
          type: 'input',
          field: 'carrier',
          label: '装货人姓名',
        },
        {
          type: 'input',
          field: 'carrier_phone',
          label: '装货人联系电话',
        },
        {
          type: 'date',
          field: 'shipment_date',
          label: '起运日期',
        },
        {
          type: 'input',
          field: 'shipment_addr',
          label: '起运地',
        },
        {
          type: 'input',
          field: 'destination',
          label: '目的地',
        },
        {
          type: 'fileUpload',
          field: 'annex',
          label: '运单附件',
        },
      ],
    },*/
    {
      name: '泥头车信息文件',
      id: 'dump_truck_file',
      submitInObject: true,
      hidden: !props.editData?.dump_truck_file,
      dataInObject: 'dump_truck_file',
      formItem: [
        {
          type: 'image',
          field: 'driver_license',
          label: '驾驶证',
        },
        {
          type: 'image',
          field: 'driving_license',
          label: '行驶证',
        },
        {
          type: 'image',
          field: 'compulsory_insurance',
          label: '强制险',
        },
        {
          type: 'image',
          field: 'commercial_insurance',
          label: '商业险',
        },
        {
          type: 'image',
          field: 'excess_insurance',
          label: '超额险',
          dataInObject: 'dump_truck_file',
        },
        {
          type: 'image',
          field: 'commitment_letter',
          label: '重点运输单位承诺书',
          dataInObject: 'dump_truck_file',
        },
        {
          type: 'image',
          field: 'monitor_return_receipt',
          label: '智能视频监控报警装置安装回执图片(中型/重型)',
          required: false
        },
      ]
    },
    {
      name: '来访信息',
      id: 'visiting_information',
      // dataInObject: 'carApplication',
      formItem: [
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          storeOptions: 'areaType',
        },
        {
          type: 'select',
          storeOptions: 'carVisitType',
          field: 'visitor_type',
          label: '申请类型',
          tips: [
            // '施工车辆访问时间不能超过一个月，通行时间段为9:00-18:00！ ',
            // '维修车辆访问时间不能超过一个月，通行时间段为9:00-18:00！',
            '临时车辆访问时间不能超过三天，通行时间段为9:00-18:00！',
            '服务商类型：危化品车辆访问时间不能超过三个月，泥头车访问时间不能超过一个月，其他车型不能超过6个月，通行时间段为9:00-18:00！',
            // '业主车辆访问时间不能超过一年',
          ],
        },
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          storeOptions: 'dept',
          label: '被访问机构',
        },
        {
          type: 'input',
          field: 'visitor_content',
          label: '来访事由',
        },
        {
          type: 'dateRange',
          startField: 'visitor_begin_time',
          endField: 'visitor_end_time',
          label: '来访时间',
        },
      ],
    },
    {
      name: '驾乘人员信息',
      id: 'carPerson',
      dataIdFiled: 'carPerson',
      dynamic: true,
      formItem: [
        {
          type: 'input',
          field: 'name',
          label: '姓名',
        },
        {
          type: 'select',
          field: 'idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'id_card',
          label: '证件号',
        },
        {
          type: 'select',
          field: 'gender',
          label: '性别',
          options: constantToOptions(gender),
        },
        {
          type: 'input',
          field: 'phone',
          label: '联系电话',
        },
        {
          type: 'select',
          field: 'type',
          label: '驾乘分类',
          storeOptions: 'driverType',
        },
        {
          //type: 'imgUpload',
          type: 'image',
          field: 'face_photo',
          label: '人像照片',
        },
      ],
    },
  ])
</script>
